import React, { useState } from 'react'

function ProjectItem(props) {

    const [showMore, setShowMore] = useState(false)
    const [showVideo, setShowVideo] = useState(false)

  return (
    <div key={props.title} id={props.title} 
        className='w-full bg-zinc-800 mb-4 border border-zinc-700 rounded-lg p-4 flex flex-col items-center space-y-1'>
        <div className='w-full flex flex-row items-start space-x-4 mb-2 relative'>           
            <div className='flex flex-col items-start space-y-2'>
                <h1 onClick={() => props.link && window.open(props.link)} className={`w-full ${props.link&&('cursor-pointer group-hover:text-zinc-100')} text-white text-left font-semibold text-lg`}>
                    {props.title}
                </h1>
                <p className='w-full max-w-[90%] text-left text-base text-zinc-300 py-1'>
                    {props.description}
                </p>
                        <div className='w-full overflow-x-hidden flex-wrap flex flex-row items-center mb-2 space-y-1'>
            {props.tech?.map(i => <span className='whitespace-nowrap rounded-full border border-zinc-600 mx-1 bg-transparent text-sm text-zinc-300 px-2'>{i}</span>)}
        </div>
                <div className='w-full flex flex-row items-center space-x-2'>
                    {props.fullDescription && (<p onClick={() => setShowMore(!showMore)} className='text-base flex items-center group text-zinc-400 cursor-pointer hover:text-zinc-200 font-medium underline text-left'>
                        {!showMore?'Read More':'Hide'}
                    </p>)}
                    {props.video && (<p onClick={() => setShowVideo(!showVideo)} className='text-base text-zinc-400 cursor-pointer hover:text-zinc-200 font-medium underline text-left'>
                        {!showVideo?'View Demo':'Hide Demo'}                        
                    </p>)}
                    {props.link && (<a href={props.link} target='__blank' className='text-base text-zinc-400 cursor-pointer hover:text-zinc-200 font-medium underline text-left flex items-center'>
                        <span>Visit Website</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="text-zinc-400 group-hover:text-zinc-200"><path d="M7 7h10v10"></path><path d="M7 17 17 7"></path></svg>                    
                    </a>)}
                    {props.github&&(<a 
                        className='text-zinc-400 hover:text-zinc-300 underline text-base font-semibold flex items-center space-x-1'
                        href={props.github||"https://github.com/imprakashraghu"} target='__blank'>
                        <span>Visit GitHub</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="text-zinc-400 group-hover:text-zinc-200"><path d="M7 7h10v10"></path><path d="M7 17 17 7"></path></svg>                    
                    </a>)}
                </div>
            </div>
            
            {
                props.image ? (
                    <img 
                        onClick={() => props.link && window.open(props.link)}
                        src={props.image}
                        className='hover:cursor-pointer opacity-50 absolute -top-2 -right-2 transform duration-200 object-contain h-14 rounded-lg'
                        alt='project__image'
                    />
                ) : null
            }
        </div>
        {
            showMore ? (
                <ul className='w-full text-left flex flex-col items-center space-y-1 list-none text-sm'>
                    {
                        props.fullDescription?.map(i => (
                            <li className='w-full rounded-lg bg-gradient-to-r from-zinc-900/70 px-2 py-1.5 text-zinc-400'>{i}</li>
                        ))
                    }
                </ul>
            ) : null
        }
        {
            showVideo && props.videoType === 'youtube' ? (
                <iframe width="300" height="200" className='py-3' src={props.video} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            ) : showVideo && props.videoType === 'local' ? (
                <video controls={true} muted={props.audio?false:true} autoPlay>
                    <source src={props.video} type="video/mp4"></source>
                </video>
            ) : null
        }
    </div>
  )
}

export default ProjectItem